<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        style="width: 120px"
        size="small"
        clearable
      >
        <el-option value="未提交">未提交</el-option>
        <el-option value="已提交">已提交</el-option>
      </el-select>
      <el-input
        v-model="query.fBillNo"
        placeholder="单据编号"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fDistributor"
        placeholder="经销商"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button-export :url="downloadUrl" type="primary" size="small">导出</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="_view"
        @select="rowSelect"
        @select-all="rowSelect"
      >
        <el-table-column prop="fBillNo" label="单据编号" width="150" />
        <el-table-column prop="fDistributor" label="经销商" />
        <el-table-column prop="fCreateTime" label="创建日期" width="200" />
        <el-table-column prop="fState" label="状态" width="80" />
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="_view(scope.row)"
            >查看</el-button>
            <template>
              <ConfirmButton
                v-if="scope.row.fState == '已审核' &&canUnudit"
                @confirm="_unaudit(scope.row)"
              >反审</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    ConfirmButton
  },
  data() {
    return {
      query: {
        fState: '未提交',
        fBillNo: null,
        fDistributor: null,

        pageIndex: 1,
        pageSize: 20
      },
      tableData: [],
      pageRecordTotal: 0,
      loading: false,
      canUnudit: true,
      canEdit: true,
      currentEditItem: null
    }
  },
  mounted() {
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '010002003') {
        this.canUnudit = val.isGrant
      }
      if (val.key == '010002002') {
        this.canEdit = val.isGrant
      }
    })
    this.refresh()
  },
  activated() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('SalesRecordManage/SalesRecordSp1/SalesRecordEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    async  _view(row) {
      var url = ''
      if (await this.billCanEdit(row.fid)) {
        url = this.$route.path + '/' + row.fid
      } else {
        url = this.$route.path + '/v/' + row.fid
      }
      this.$router.push(url)
    },
    _unaudit: function(row) {
      this.loading = true
      this.$httpPost('SalesRecordManage/SalesRecordSp1/SalesRecordUnApproval', {
        fid: row.fid
      }).then((res) => {
        if (!res.isSuccess) {
          this.loading = false
          this.$message.error(res.message)
          return
        }
        this.$message.success(res.message)
        this.refresh()
      })
    },
    billCanEdit: function(id) {
      if (!this.canEdit) return false

      return this.$httpPost('OrderManage/GetBillState', { fid: id, key: 'SalesRecordSP1' })
        .then(res => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return false
          }
          return !res.datalist
        })
    },
    rowSelect(row) {
      console.log(row)
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/SalesRecordEntryDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        // if (rtn.startGroupNumber == "") rtn.startGroupNumber = null;
        // if (rtn.endGroupNumber == "") rtn.endGroupNumber = null;
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    }

  }
}
</script>
